import React from 'react';
import PropTypes from 'prop-types';

const Title = ({title, isOpen, onClick}) => {
  return (
    <a className="filter-toggle text-dark" onClick={onClick}>
      {title} <i className={`icon icon-${isOpen ? 'down' : 'up'}-arrow`} />
    </a>
  );
};

Title.propTypes = {
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default Title;
